import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import classNames from 'classnames';
import { withCookies, Cookies } from 'react-cookie';
import * as CustomPropTypes from 'lib/CustomPropTypes';

import Link from 'components/Link';

import {
  loadLocationByIp,
  loadLocationByZip,
  loadNews,
  manuallySetLocation,
} from 'redux/modules/localnews';

import stateSVGs from './states';

const mapStateToProps = ({ localnews }) => ({
  news: localnews.news,
  zip: localnews.zip,
  city: localnews.city,
  state: localnews.state,
  latitude: localnews.latitude,
  longitude: localnews.longitude,
});

@connect(mapStateToProps)
class LocalNews extends React.Component {
  cookieName = 'localnews';

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    news: PropTypes.arrayOf(PropTypes.any).isRequired,
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    zip: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    narrow: PropTypes.bool,
    content: CustomPropTypes.package.isRequired,
    pkgClassName: PropTypes.string,
  };

  static contextTypes = {
    store: PropTypes.shape({}),
  };

  static defaultProps = {
    zip: null,
    city: null,
    state: null,
    latitude: 0,
    longitude: 0,
    narrow: false,
    pkgClassName: 'pkg localNews',
  };

  constructor(props) {
    super(props);

    this.state = {
      locationChangeIsOpen: false,
      regionChange: null,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { cookies, dispatch } = this.props;

    if (cookies && cookies.get(this.cookieName)) {
      // Populate store with cookied data.
      const cookieVals = cookies.get(this.cookieName).split('=');
      const [, zip, , , city, state] = cookieVals;
      let [, , latitude, longitude] = cookieVals;

      // These vals can be NaN in edge cases, so default to New York
      latitude = this.parseCoordinate(latitude, 40.7128);
      longitude = this.parseCoordinate(longitude, 74.0060);

      const formatted = {
        zip, city, state, latitude, longitude,
      };
      dispatch(manuallySetLocation(formatted));

      // Fetch new localNews articles.
      dispatch(loadNews(zip, latitude, longitude));
    } else {
      // Find locaiton by IP.
      dispatch(loadLocationByIp());
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate(nextProps) {
    const { zip: nextZip } = nextProps;
    const { zip: prevZip, state: prevState, dispatch } = this.props;

    // Check changes to city.
    if (prevZip !== nextZip) {
      const { city, state } = nextProps;
      let { latitude, longitude } = nextProps;
      // These vals can be NaN in edge cases, so default to New York
      latitude = this.parseCoordinate(latitude, 40.7128);
      longitude = this.parseCoordinate(longitude, 74.0060);

      // Store old region.
      // TODO, fix this
      // eslint-disable-next-line react/no-will-update-set-state
      this.setState({ regionChange: prevState });

      // Fetch new localNews articles.
      dispatch(loadNews(nextZip, latitude, longitude));

      // Update cookie.
      const { cookies } = nextProps;
      const cookieValue = `pi6=${nextZip}=${latitude}=${longitude}=${city}=${state}`;
      cookies.set(this.cookieName, cookieValue, { maxAge: (14 * 86400), path: '/' });
    }
  }

  article = (article) => (
    <li key={article.title} className="collection__article">
      <div className="collection__info">
        <h3 className="collection__title">
          <a href={article.link} target="_blank" rel="noopener noreferrer">{article.title}</a>
        </h3>
      </div>
    </li>
  );

  toggleLocationChange = () => {
    const { locationChangeIsOpen } = this.state;
    this.setState({
      locationChangeIsOpen: !locationChangeIsOpen,
    });
  }

  /**
   * In rare edge cases these coords can turn up NaN from cookies. This function checks for that
   * and returns a safe default value.
   */
  parseCoordinate = (coord, defaultCoord) => {
    const parsed = parseFloat(coord);

    return typeof parsed === 'number' && !Number.isNaN(parsed)
      ? parsed
      : defaultCoord;
  }

  handleSubmit = (event) => {
    const { dispatch } = this.props;
    event.preventDefault();
    const zipCode = this.inputZip.value;
    if (zipCode && zipCode.length === 5) {
      // Get new location data.
      dispatch(loadLocationByZip(zipCode));
      this.toggleLocationChange();
    }
  }

  backgroundImage() {
    const { city, state: newState } = this.props;
    const { regionChange: oldState } = this.state;

    if (newState !== oldState) {
      setTimeout(() => {
        this.setState({ regionChange: newState });
      }, 500);
    }

    return (
      <span className={classNames('local-news__background', { 'local-news__background--animated': newState !== oldState })}>
        <img alt={city} src={(oldState && stateSVGs[oldState]) || stateSVGs.NY} />
        {newState !== oldState && <img alt={city} src={(newState && stateSVGs[newState])} />}
      </span>
    );
  }

  render() {
    const { locationChangeIsOpen } = this.state;
    const {
      content: { id }, news, city, narrow, pkgClassName,
    } = this.props;

    let affiliateLabel = i18next.t('Local news around you');
    if (news && news.length) {
      affiliateLabel = `${affiliateLabel} from ${news[0].link.split('/')[2].replace('www.', '')}`;
    }

    const containerClass = classNames(pkgClassName, 'collection__container', {
      collection__wide: !narrow,
    });

    const headerClass = classNames('local-news__header', {
      'local-news__header--change-location-open': locationChangeIsOpen,
    });

    return (
      <div data-packageid={id} className={containerClass}>
        <div className={headerClass}>
          <div className="local-news__headings">
            <h2 className="local-news__heading">{city || i18next.t('unknown')}</h2>
            <div className="local-news__change-location">
              <div className="local-news__form-wrapper">
                <form onSubmit={this.handleSubmit}>
                  <input
                    className="local-news__zip-code"
                    ref={(input) => { this.inputZip = input; }}
                    type="text"
                    required
                    maxLength="5"
                    placeholder={i18next.t('Zip code here')}
                  />
                  <input className="local-news__zip-submit" type="submit" value={i18next.t('Submit')} />
                </form>
              </div>
            </div>
            <button type="button" className="local-news__change-location-toggle" onClick={this.toggleLocationChange}>
              <span className={classNames('icon', `icon-${locationChangeIsOpen ? 'close' : 'angle-down'}`)} />
            </button>
            <h2 className="local-news__subheading">{affiliateLabel}</h2>
          </div>
          {this.backgroundImage()}
        </div>
        <ul className="collection__articles">
          {(() => {
            if (news && news.length) {
              return news.slice(0, 7).map((item) => this.article(item));
            }
            return (
              <li className="collection__article">
                {i18next.t('We apologize, we were unable to find your local news.  Please try another location.')}
              </li>
            );
          })()}
        </ul>
        <div className="collection__more">
          <Link to="https://www.nbcnews.com/news/us-news/nbc-affiliates-n19981">{i18next.t('See local affiliates')}</Link>
        </div>
      </div>
    );
  }
}

export default withCookies(LocalNews);
